import { render, staticRenderFns } from "./ErpcDetail.vue?vue&type=template&id=63a13f85&scoped=true"
import script from "./ErpcDetail.vue?vue&type=script&lang=ts"
export * from "./ErpcDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a13f85",
  null
  
)

export default component.exports